"use client"

import { Button } from '@/components/ui/button';
import { useRouter, useSearchParams } from 'next/navigation';

interface ShopPaginationProps {
  currentPage: number;
  totalPages: number;
}

export function ShopPagination({ currentPage, totalPages }: ShopPaginationProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const updateParams = (newParams: Record<string, string>) => {
    const params = new URLSearchParams(searchParams);
    
    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    
    router.push(`/shop?${params.toString()}`);
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2 mt-12">
      <Button
        variant="outline"
        size="sm"
        disabled={currentPage === 1}
        onClick={() => updateParams({ page: (currentPage - 1).toString() })}
      >
        Previous
      </Button>
      
      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
        const pageNum = i + 1;
        return (
          <Button
            key={pageNum}
            variant={currentPage === pageNum ? "default" : "outline"}
            size="sm"
            onClick={() => updateParams({ page: pageNum.toString() })}
          >
            {pageNum}
          </Button>
        );
      })}
      
      <Button
        variant="outline"
        size="sm"
        disabled={currentPage === totalPages}
        onClick={() => updateParams({ page: (currentPage + 1).toString() })}
      >
        Next
      </Button>
    </div>
  );
} 